<template>
  <div class="search">
    <div class="container">
      <div class="header">
        <div>
          <span>搜尋</span>
        </div>
      </div>
      <div class="search">
        <div class="search_bar_root">
          <input
            id="search_input"
            placeholder="樓盤名稱或區份"
            type="text"
            v-model="buildingName"
            @keypress="searchIfEnter"
          >
          <button
            class="ui button search"
            v-if="isDesktop()"
            @click="search"
          >
            <span>
              <img
                src="@/assets/web_icons/search_icon.png"
                alt="search"
              >
            </span>
          </button>
          <button
            class="ui button clear"
            v-if="!isDesktop()&&buildingName.length"
            @click="buildingName=''"
          >
            <span>
              <img
                src="@/assets/web_icons/cross_icon.png"
                alt="cross"
              >
            </span>
          </button>
          <button
            class="ui button more"
            @click="toggleModal()"
          >
            <span>
              <img
                src="@/assets/web_icons/more_menu_icon.png"
                alt="more"
              >
            </span>
          </button>
        </div>
      </div>
      <div
        class="more"
        :class="more?'open':'close'"
      >
        <div class="row-0 header">
          <img
            class="close"
            src="@/assets/web_icons/cross_icon.png"
            alt="cross"
            @click="closeModal()"
          >
        </div>
        <div class="row-1 status">
          <div
            class="forSell"
            :class="status==='forSell'?'active':''"
            @click="status='forSell'"
          >售</div>
          <div
            class="forRent"
            :class="status==='forRent'?'active':''"
            @click="status='forRent'"
          >租</div>
        </div>
        <div class="row-2 price">
          <input
            placeholder="0"
            class="input"
            type="number"
            name="lowPrice"
            id="lowPrice"
            v-model="lowPrice"
          >
          <div class="middle">
            <div>價錢</div>
            <div>至</div>
          </div>
          <input
            placeholder="0"
            class="input"
            type="number"
            name="highPrice"
            id="highPrice"
            v-model="highPrice"
          >
        </div>
        <div class="row-3 area">
          <input
            placeholder="0"
            class="input"
            type="number"
            name="lowGrossArea"
            id="lowGrossArea"
            v-model="lowGrossArea"
          >
          <div class="middle">
            <div>建築面積</div>
            <div>至</div>
          </div>
          <input
            placeholder="0"
            class="input"
            type="number"
            name="highGrossArea"
            id="highGrossArea"
            v-model="highGrossArea"
          >
        </div>
        <div class="row-4 bedroom">
          <div class="label">
            <img src="@/assets/web_icons/badroom.png">
            <div> {{bedroomRange[0]}}-{{bedroomRange[1]}}</div>
          </div>
          <vue-slider
            class="slider"
            v-bind:max="10"
            v-model="bedroomRange"
          ></vue-slider>
        </div>
        <div class="row-5 compass">
          <div
            :class="compass['東']?'active':''"
            @click="toggleCompass('東')"
          >東</div>
          <div
            :class="compass['東南']?'active':''"
            @click="toggleCompass('東南')"
          >東南</div>
          <div
            :class="compass['南']?'active':''"
            @click="toggleCompass('南')"
          >南</div>
          <div
            :class="compass['西南']?'active':''"
            @click="toggleCompass('西南')"
          >西南</div>
          <div
            :class="compass['西']?'active':''"
            @click="toggleCompass('西')"
          >西</div>
          <div
            :class="compass['西北']?'active':''"
            @click="toggleCompass('西北')"
          >西北</div>
          <div
            :class="compass['北']?'active':''"
            @click="toggleCompass('北')"
          >北</div>
          <div
            :class="compass['東北']?'active':''"
            @click="toggleCompass('東北')"
          >東北</div>
        </div>
        <!-- <div class="flex-1"></div> -->
        <div class="row-6 submit">
          <button @click="search()">
            搜尋
          </button>
        </div>
      </div>
    </div>
    <div class="properties">
      <div>{{searchTagLine}}</div>
      <BeatLoader v-if="searching"></BeatLoader>
      <PropertyCardList v-bind:properties="properties"></PropertyCardList>
    </div>
  </div>
</template>

<style>
.vue-slider-process {
  background-color: #0f0a9f !important;
}
.vue-slider-dot-tooltip-inner {
  background-color: #0f0a9f !important;
  border-color: #0f0a9f !important;
}
.flex-1 {
  flex: 1;
}
</style>

<style lang="scss" scoped>
.search.main {
  min-height: calc(100vh - 58px);
  // background-color: white;
  > .container {
    box-sizing: border-box;
    position: relative;
    width: 95%;
    padding: 16px 20px 10px;
    margin: auto auto 20px;
    > .header {
      padding: 0;
      text-align: left;
      > div {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 15px;
        margin-left: 15px;
        line-height: 50px;
        > span {
        }
      }
    }
    > .search {
      .search_bar_root {
        transition: all 0.2s ease;
        width: 100%;
        margin-bottom: 16px;
        position: relative;
        font-weight: 400;
        font-style: normal;
        display: inline-flex;
        color: rgba(0, 0, 0, 0.87);
        font-size: 1em;
        input#search_input {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-right-color: transparent !important;
          margin: 0;
          max-width: 100%;
          width: 1px;
          flex: 1 0 auto;
          outline: 0;
          text-align: left;
          padding: 0.67857143em 1em;
          color: rgba(0, 0, 0, 0.87);
          transition: box-shadow 0.1s ease, border-color 0.1s ease;
          box-shadow: none;
          // background: #f5f5f5 !important;
          background: white !important;
          border: none !important;
          border-radius: 0 !important;
          line-height: 30px !important;
          font-size: 15px;
          appearance: none;
        }
        button {
          align-items: center;
          flex: 0 0 auto;
          cursor: pointer;
          display: inline-block;
          min-height: 1em;
          outline: 0;
          border: none;
          vertical-align: baseline;
          margin: 0;
          text-transform: none;
          text-shadow: none;
          font-weight: 700;
          line-height: 1em;
          font-style: normal;
          text-align: center;
          text-decoration: none;
          box-shadow: 0 0 0 1px transparent inset,
            0 0 0 0 rgba(34, 36, 38, 0.15) inset;
          user-select: none;
          transition: opacity 0.1s ease, background-color 0.1s ease,
            color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease,
            -webkit-box-shadow 0.1s ease;
          will-change: "";
          -webkit-tap-highlight-color: transparent;
          // background: #f5f5f5 !important;
          background: white;
          color: hsl(213, 5%, 39%);
          border-radius: 0 !important;
          padding: 0 30px !important;
          font-size: 15px !important;
          appearance: button;
          > span {
            > img {
              height: 1em;
            }
          }
        }
        button.search,
        button.clear {
          &:hover {
            background-color: darken(white, 10%);
          }
          &:active {
            background-color: darken(white, 15%);
          }
        }
        button.more {
          background-color: white;
          &:hover {
            background-color: darken(white, 10%);
          }
          &:active {
            background-color: darken(white, 15%);
          }
        }
      }
    }
    > .more {
      display: none;
      &.open {
        z-index: 3;
        @media all and (min-width: 769px) {
          position: absolute;
          width: 100%;
          max-width: 600px;
          left: 50vw;
          transform: translate(-50%, 0);
        }
        @media all and (max-width: 768px) {
          position: fixed;
          top: 0;
          left: 0;
          height: 100vh;
          width: 100vw;
        }
        background-color: #fff;
        display: flex;
        flex-direction: column;
        padding: 16px;
        box-shadow: -3px 3px 4px 0px rgba(0, 0, 0, 0.11);
        box-sizing: border-box;
        .input {
          margin: 0;
          max-width: 100%;
          flex: 1 0 auto;
          outline: 0;
          text-align: left;
          // padding: 0.67857143em 1em;
          color: rgba(0, 0, 0, 0.87);
          transition: box-shadow 0.1s ease, border-color 0.1s ease;
          box-shadow: none;
          background: #f5f5f5;
          border: 1px solid darken(#f5f5f5, 10%);
          border-radius: 10px;
          line-height: 30px !important;
          flex: 1;
          font-size: 1.5rem;
          appearance: none;
          text-align: center;
          &:active,
          &:focus {
            background: white;
            border: 1px solid #100ab2;
          }
        }
        .row-0.header {
          display: none;
          @media all and (max-width: 768px) {
            display: flex;
          }
          height: 2rem;
          justify-content: flex-start;
          align-items: center;
          padding: 0 8px;
          margin-bottom: 8px;
          img {
            width: auto;
            height: 1rem;
            padding: 12px;
            cursor: pointer;
          }
        }
        .row-1.status {
          -webkit-tap-highlight-color: transparent;
          cursor: pointer;
          position: relative;
          display: flex;
          justify-content: center;
          height: 2rem;
          width: 100%;
          margin: 0 auto;
          // border: 1px solid black;
          border-radius: 20px;
          box-shadow: -3px 3px 4px 0px rgba(0, 0, 0, 0.11),
            3px 3px 4px 0px rgba(0, 0, 0, 0.11);
          > div {
            position: absolute;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            height: 2rem;
            &.forSell {
              left: 0;
              top: 0;
            }
            &.forRent {
              right: 0;
              top: 0;
            }
            &.active {
              background-color: #100ab2;
              color: white;
            }
          }
        }
        .row-2.price {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 4rem;
          padding: 8px 0;
          margin-top: 8px;
          > * {
            flex: 0 0 33%;
            box-sizing: border-box;
            width: 33%;
            height: 100%;
          }
          > .middle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            :first-child {
              font-size: 1.2rem;
            }
            width: 8rem;
          }
        }
        .row-3.area {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 4rem;
          padding: 8px 0;
          > * {
            flex: 0 0 33%;
            box-sizing: border-box;
            width: 33%;
            height: 100%;
          }
          > .middle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            :first-child {
              font-size: 1.2rem;
            }
            width: 8rem;
          }
        }
        .row-4.bedroom {
          > .label {
            display: flex;
            justify-content: center;
            align-items: center;
            > img {
              width: 2rem;
              margin-right: 8px;
            }
          }
          > .slider {
            width: 95% !important;
            margin: 0 auto;
          }
        }
        .row-5.compass {
          -webkit-tap-highlight-color: transparent;

          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          position: relative;
          height: 2rem;
          width: 100%;
          margin: 1rem auto;
          border-radius: 20px;
          box-shadow: -1px 1px 0.5px 0.5px rgba(0, 0, 0, 0.11),
            1px 1px 0.5px 0.5px rgba(0, 0, 0, 0.11),
            -1px -1px 0px 0px rgba(0, 0, 0, 0.11),
            1px -1px 0px 0px rgba(0, 0, 0, 0.11);
          > div {
            width: 12.5%;
            border-right: 1px solid rgba(0, 0, 0, 0.21);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            &:first-child {
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            }
            &:last-child {
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              border-right: none !important;
            }
            &.active {
              background-color: #100ab2;
              color: white;
              border-right: 1px solid rgba(255, 255, 255, 0.21);
            }
          }
        }
        .row-6.submit {
          button {
            @media all and (max-width: 768px) {
              // position: fixed;
              // left: 0;
              // top: calc(100vh - 3.5em);
            }

            background-image: linear-gradient(
              to right,
              #2111b9 0%,
              #8e4cd2 100%
            );
            outline: 0;
            -webkit-tap-highlight-color: transparent;
            border-radius: 20px;
            appearance: button;
            user-select: none;
            width: 100%;
            height: 2.5rem;
            font-size: 1rem;
            color: white;
          }
        }
      }
    }
    > .properties {
      margin-top: 50px;
    }
  }
}
</style>

<script>
// @ is an alias to /src
import PropertyCardList from "@/components/PropertyCardList.vue";
import axios from "axios";
import _ from "lodash";
import { BeatLoader } from "@saeris/vue-spinners";

export default {
  name: "search",
  components: {
    PropertyCardList
  },
  data() {
    return {
      buildingName: "",
      properties: [],
      more: false,
      bedroomRange: [0, 10],
      status: "all",
      lowPrice: null,
      highPrice: null,
      lowGrossArea: null,
      highGrossArea: null,
      compass: {
        東: false,
        東南: false,
        南: false,
        西南: false,
        西: false,
        西北: false,
        北: false,
        東北: false
      },
      searching: false,
      searchTagLine: ""
    };
  },
  methods: {
    search() {
      this.properties = [];
      this.searching = true;
      this.closeModal();
      const compassMapping = _.invert(this.$getConst("COMPASS_MAPPING"));
      const params = _.pickBy(
        {
          buildingName: this.buildingName,
          lowPrice: this.lowPrice,
          highPrice: this.highPrice,
          lowBedroom: this.bedroomRange[0],
          highBedroom: this.bedroomRange[1],
          lowGrossArea: this.lowGrossArea,
          highGrossArea: this.highGrossArea,
          compass: Object.keys(_.pickBy(this.compass, a => a)).map(
            a => compassMapping[a]
          ),
          status: this.status
        },
        (v, k) => {
          return v;
        }
      );
      axios
        .get("https://api.topagentmo.com/api/advertiseProperties", {
          params
        })
        .then(res => res.data)
        .then(d => {
          // this.searchTagLine = "hi";
          this.properties = d;
        })
        .catch(e => null)
        .then(() => {
          this.searching = false;
        });
    },
    toggleCompass(c) {
      this.compass[c] = !this.compass[c];
    },
    isDesktop() {
      return this.$resize && this.$mq.above(769);
    },
    toggleModal() {
      this.more ? this.closeModal() : this.showModal();
    },
    showModal() {
      if (!this.isDesktop()) {
        document.getElementById("app").style.overflow = "hidden";
        document.getElementById("app").style.height = "100vh";
      }
      this.status = "forSell";
      document.getElementById("nav").style["z-index"] = 0;
      this.more = true;
    },
    closeModal() {
      if (!this.isDesktop()) {
        document.getElementById("app").style.overflow = null;
        document.getElementById("app").style.height = null;
      }
      document.getElementById("nav").style["z-index"] = null;
      this.more = false;
    },
    searchIfEnter(e) {
      if (e.charCode === 13) {
        document.getElementById("search_input").blur();
        this.search();
      }
    }
  },
  mounted() {
    this.search();
  }
};
</script>
